export class IncidentDataFilterparameterViewModel {
    public cluster: string[];
    public site: string[];
    public bigcategory: string[];
    public currency: string[];
    public year: number;
}

export interface InicedentData {
    id: number;
    incidentfileid?: number;
    productiondate?: Date;
    productcode?: string;
    productdescription?: string;
    materialtype?: string;
    defectmodeaggregation?: string;
    packagingmateriallevel?: string;
    cluster?: string;
    bigcategory?: string;
    subcategory?: string;
    product?: string;
    defecttypecode?: string;
    formatsize?: string;
    losstree?: string;
    leveL0?: string;
    leveL1?: string;
    leveL2?: string;
    leveL3?: string;
    leveL4?: string;
    leveL5?: string;
    defectseveritygrade?: string;
    productionline?: string;
    noofblockedproduct?: number;
    averagebatchqty?: number;
    uom?: string;
    affectedproductpercentage?: number;
    frequencyscore?: number;
    processpoint?: string;
    fourms?: string;
    detectionpoint?: string;
    detectability?: string;
    eincident?: string;
    rework?: string;
    ambercrqs?: string;
    qualityrelatedwaste?: string;
    dincidents?: string;
    palletnonconformance?: string;
    customernonconformance?: string;
    onshelfcrqs?: string;
    consumercomplaints?: string;
    marketplaceincident?: string;
    costoF1PC: number;
    totaldefectcost: number;
    totalcostpercentage: number;
    costscore: number;
    detectabilityindex: number;
    severityindex: number;
    frequencyindex: number;
    costindex: number;
    defectpriorityindex: number;
    dpivstotaldpipercentage: number;
    cummulativedpi: number;
    dpidefectclass?: string;
    man: boolean;
    machine: boolean;
    method: boolean;
    material: boolean;
    pdcastatus?: string;
    sites?: string;
    localcurrency?: string;
    totaldefectcosteuro: number;
    inserteddate: Date;
    insertedby?: string;
    updateddate: Date;
    updatedby?: string;
    updateD_PDCASTATUS: Date;
    lasT_PDCASTATUS_UPDATEDDATE: Date;
  }
